import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import BasicPreview from 'features/creative/preview/BasicPreview'
import { fail } from 'features/toast/Toast'
import NoneAnchor from 'components/NoneAnchor'
import { Assets } from 'features/Codes'
import TalkChannelPreview from './TalkChannelPreview'

const Preview = ({ type, data }) => {
  const { basicCreative, buildCreative } = useSelector(state => state.creative)
  const [isMobileView, setMobileView] = useState(true)
  const isTalkChannelAsset = useMemo(
    () =>
      type === Assets.THUMBNAIL_RECOMMEND.name ||
      type === Assets.THUMBNAIL_CUSTOM.name,
    [type]
  )
  return (
    <div className="view_material">
      <div className="view_tit">
        <strong className="tit_view">미리보기</strong>
        <ul className="tab_view">
          <li className={classNames({ on: isMobileView })}>
            <NoneAnchor
              className="link_tab"
              onClick={() => setMobileView(true)}>
              모바일
            </NoneAnchor>
          </li>
          {!isTalkChannelAsset && (
            <li className={classNames({ on: !isMobileView })}>
              <NoneAnchor
                className="link_tab"
                onClick={() => {
                  if (type === 'PHONE_NUMBER') {
                    fail('전화번호 확장소재는 PC에 노출되지 않습니다.')
                  } else {
                    setMobileView(false)
                  }
                }}>
                PC
              </NoneAnchor>
            </li>
          )}
        </ul>
      </div>
      <div
        className={classNames('view_detail', {
          view_mo: isMobileView,
          view_pc: !isMobileView,
        })}>
        {isTalkChannelAsset ? (
          <TalkChannelPreview
            channel={buildCreative.channel}
            basic={basicCreative}
            type={type}
            data={data}
          />
        ) : (
          <BasicPreview
            channel={buildCreative.channel}
            basic={basicCreative}
            type={type}
            data={data}
            isMobileView={isMobileView}
          />
        )}
      </div>
      {[Assets.THUMBNAIL.name, Assets.MULTI_THUMBNAIL.name].includes(type) && (
        <div className="view_guide">
          <ul className="view_list">
            <li>
              저작권, 초상권을 침해할 수 있는 이미지는 사용 불가하며, 권리침해
              분쟁이 발생할 경우 회사가 해당 광고의 노출을 중단할 수 있습니다.
            </li>
          </ul>
        </div>
      )}
      {isTalkChannelAsset && (
        <div className="view_guide">
          <ul className="view_list">
            <li>실제 노출과 미리보기는 다를 수 있습니다.</li>
            <li>
              타인의 권리(지적재산권, 초상권 등)를 침해하는 이미지는 사용
              불가합니다.
            </li>
            <li>
              권리침해 분쟁이 발생할 경우 회사가 해당 광고의 노출을 중단할 수
              있습니다.
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default Preview

Preview.propTypes = {
  type: PropTypes.string,
  data: PropTypes.any,
  importCreative: PropTypes.bool,
}
